import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import AdminLayout from "layouts/Admin.js";
import Auth from "./layouts/Auth";
import TradeIn from "./layouts/TradeIn";
import PurchaserAdmin from "./layouts/PurchaserAdmin";
import PurchaserAuth from "./layouts/PurchaserAuth";
import ApiDoc from './views/ApiDoc'
import "./App.css"


ReactDOM.render(<BrowserRouter>
	<Switch>
		<Route path="/auth" render={(props) => <Auth {...props} />} />
		<Route path="/admin" render={(props) => <AdminLayout {...props} />} />
		<Route path="/trade-in" render={(props) => <TradeIn {...props} />} />
		<Route path="/purchaser" render={(props) => <PurchaserAdmin {...props} />} />
		<Route path="/purchaser-auth" render={(props) => <PurchaserAuth {...props} />} />
		<Route path="/api/docs" component={(props) => <ApiDoc {...props} apiDocfileName={process.env.REACT_APP_APIDOCS_FILE} />} />
		<Redirect from="/" to="/auth/login" />
	</Switch>
</BrowserRouter>, document.getElementById("root"));
